module.exports = __webpack_public_path__ + "media/application/images/svgs/quote-ea3368d3506b576aaa60d3438c5a8494.svg";